<template>
  <div v-if="!isKioskModeEnabled" class="pdp-add-to-cart">
    <div v-if="isRetailerOnly || !options.eCommAvailable">
      <div v-if="isRetailerOnly" class="alert negative" v-html="bp('inStoreOnly')" />
      <trek-link
        button
        primary
        block
        icon="pin_drop"
        :href="withContextPath('/store-finder/')"
        data-ga-event="find-a-store-cta"
        data-ga-category="Find a Store CTA"
        data-ga-action="Item Not Available for Purchase"
      >
        <span v-html="bp('retailerButtonCaption')" />
      </trek-link>
    </div>
    <div v-else-if="isAddToCartVisible" class="mb-1">
      <pdl-callout v-if="stockStatusText" qaid="stock-status-message" :kind="stockStatusCalloutType">
        <template #content>
          <span v-html="bp(`${stockStatusText}`)" />
        </template>
      </pdl-callout>
      <trek-button
        id="addToCartButton"
        primary
        block
        icon="shopping_cart"
        :disabled="!isAddToCartEnabled"
        type="submit"
        @click.prevent="addToCart"
      >
        <span id="add-button" v-html="addToCartButtonCaption" />
      </trek-button>
      <pdp-add-to-cart-status :message="message" :base-properties="baseProperties" />
    </div>
    <pdp-replacement
      v-if="product.isArchived && variantCode"
      :replacement-product="replacementProduct"
      :base-properties="baseProperties"
    />
  </div>
</template>
<script>
import PdpAddToCartStatus from '@/components/containers/pdp/PdpAddToCartStatus';
import {Url} from '@/utils/url';
import get from 'lodash/get';
import PdpReplacement from '@/components/containers/pdp/PdpReplacement';
import {isInStockByCode} from '@/components/containers/pdp/utils/retailer-helpers';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import Variant from '@/utils/variant-helpers';
import {mapState, mapGetters} from 'vuex';

export default {
  name: 'PdpAddToCart',
  components: {PdpReplacement, PdpAddToCartStatus, TrekButton, TrekLink},
  props: {
    addToCartButtonCaption: {
      type: String,
      default: '',
    },
    variantCode: {
      type: String,
      default: '',
    },
    isAddingToCart: {
      type: Boolean,
      default: false,
    },
    stockMessage: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      required: true,
    },
    isPurchasable: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      quantity: 1,
    };
  },
  computed: {
    ...mapState('pdp', ['isECommAvailable', 'isLocallyActive']),
    ...mapGetters('backend', ['b2b']),

    stockStatusText() {
      if (this.b2b || this.isECommAvailable) {
        return this.stockMessage.description;
      } else {
        if (this.isLocallyActive) {
          return this.stockMessage.nonECommDescription;
        } else {
          return this.stockMessage.nonECommNonLocallyDescription;
        }
      }
    },

    stockStatusCalloutType() {
      if (this.isECommAvailable) {
        return this.stockMessage.calloutType;
      } else {
        return 'default';
      }
    },

    isKioskModeEnabled() {
      return this.options.kioskModeEnabledOnSite;
    },

    currentVariant() {
      return Variant(this.variantCode, this.product).get();
    },

    isAddToCartVisible() {
      return !this.product.isArchived;
    },

    isAddToCartEnabled() {
      return this.isPurchasable && !this.isAddingToCart && isInStockByCode(this.currentVariant?.globalStockStatus);
    },
    replacementProduct() {
      if (!this.variantCode) {
        return null;
      }

      return get(
        this.product.variants.find((variant) => variant.code === this.variantCode),
        'replacementProduct'
      );
    },

    isRetailerOnly() {
      return this.product.retailerOnly || this.isVariantRetailerOnly;
    },

    isVariantRetailerOnly() {
      if (!this.variantCode) {
        return null;
      }

      return this.currentVariant.retailerOnly;
    },
  },

  methods: {
    withContextPath: (url) => Url.withContextPath(url),
    addToCart() {
      this.$emit('add-to-cart', this.quantity);
    },
  },
};
</script>
